import React from "react";
import {
  useInvestmentPerformance,
  useInvestmentsId,
  useTradingGainForInvestment,
} from "@bn/api/apiv1";
import { GainLossStatistics } from "./GainLossStatistics";

interface Props {
  investmentId: number;
}

export const GainLossStatisticsLoader = ({ investmentId }: Props) => {
  const { data: investment, isFetching: isInvestmentLoading } =
    useInvestmentsId(
      { id: investmentId },
      { enabled: investmentId !== undefined }
    );

  const {
    data: realizedGainByBooking,
    isFetching: isRealizedGainByBookingLoading,
  } = useTradingGainForInvestment(
    { id: investmentId },
    { enabled: investmentId !== undefined }
  );

  const {
    data: investmentPerformance,
    isFetching: isInvestmentPerformanceLoading,
  } = useInvestmentPerformance(
    { id: investmentId },
    { enabled: investmentId !== undefined }
  );

  const isFetching =
    isInvestmentLoading ||
    isInvestmentPerformanceLoading ||
    isRealizedGainByBookingLoading;

  return (
    <GainLossStatistics
      isFetching={isFetching}
      investment={investment}
      realizedGainByBooking={realizedGainByBooking}
      investmentPerformance={investmentPerformance}
      currency={investment?.currency}
    />
  );
};
